<template>
  <div class="residence">
    <div class="residence__header">
      <img :alt="`Photograph of residence: ${searchResult.Fields.Title.Value}`" :src="`https://bristol.ac.uk/${searchResult.Fields.Image.Value}`" height="300" width="600">
      <span>From <strong>&pound;{{ searchResult.Fields.TotalTenancyCost.Value }}</strong></span>
    </div>
    <div class="residence__main">
      <h1>{{ searchResult.Fields.Title.Value }}</h1>
      <h2>{{ searchResult.Fields.Village.Value }}</h2>
    </div>
    <div class="residence__footer">
      <ul>
        <li class="icon-bed">{{ searchResult.Fields.NumberOfPlaces.Value }} places</li>
        <li class="icon-walk">{{ searchResult.Fields.DistanceCampusMiles.Value }} miles to campus</li>
        <li class="icon-spoon-knife">{{ cateringOptions }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SearchResult',
    props: {
      searchResult: Object
    },
    computed: {

      /*
       * Determines a residences catering options and returns those as a string
       *
       * @returns {string}
       */
      cateringOptions() {

        // Create empty array for storing catering options
        let cateringOptions = []

        // Retrieve both catered and self-catered Cludo fields
        const catered = this.searchResult.Fields['Catered']
        const selfCatered = this.searchResult.Fields['SelfCatered']
        
        // Determine if catered exists, and if so, whether its true
        if (catered && catered.Value == 'Yes') {

          // Push "Half-board" to catering options
          cateringOptions.push('Catered')
        }

        // Determine if self-catered exists, and if so, whether its true
        if (selfCatered && selfCatered.Value == 'Yes') {

          // Push "Self-catered" to catering options
          cateringOptions.push('Self-catered')
        }

        // Return all catering options as a string, joined by " and "
        return cateringOptions.join(' and ')
      }
    }
  }
</script>
